module.exports = __webpack_public_path__ + "assets/1233b9637a1abdf5e48073e2fb8fed66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/O-Silver-Partner-clr.png
// module id = 587
// module chunks = 0